define('views/modules/calendar/animated-session/exercise/cardio/week-brief/cardio-brief-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // parent view
    'views/modules/calendar/animated-session/exercise/cardio/cardio-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // parent view
    VCardioExerciseContent
) {

    var VCardioBriefContent = VCardioExerciseContent.extend({
    });

    return VCardioBriefContent;

});

